import { render, staticRenderFns } from "./SpeakerPreviewCard.vue?vue&type=template&id=6bd10b1e&scoped=true&"
import script from "./SpeakerPreviewCard.vue?vue&type=script&lang=js&"
export * from "./SpeakerPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerPreviewCard.vue?vue&type=style&index=0&id=6bd10b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd10b1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCol,VImg,VRow})
